<div class="ept-root flex flex-col h-full">
    <!-- Toolbar — never printed -->
    <div class="ept-noprint flex items-center justify-between gap-4 px-5 py-3 border-b border-slate-200 bg-slate-50 shrink-0">
        <div class="min-w-0">
            <h2 class="text-base font-bold text-slate-900 truncate">{{ 'exitTicketPrint.title' | translate }}</h2>
            <p class="text-xs text-slate-500">
                {{ data.easypass.title }} · {{ unusedCodes().length }} / {{ codes().length }}
                @if (usedCount() > 0) { · {{ usedCount() }} {{ 'exitTicketPrint.used' | translate }} }
            </p>
        </div>
        <div class="flex items-center gap-2">
            <button type="button" (click)="print()" [disabled]="isLoading() || unusedCodes().length === 0"
                class="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 rounded-xl">
                <mat-icon class="!w-4 !h-4 !text-[18px] leading-4">print</mat-icon>
                {{ 'exitTicketPrint.print' | translate }}
            </button>
            <button type="button" (click)="close()"
                class="px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-200/60 rounded-xl">
                {{ 'exitTicketPrint.close' | translate }}
            </button>
        </div>
    </div>

    <div class="ept-scroll flex-1 overflow-auto bg-slate-200">
        @if (isLoading()) {
        <div class="flex justify-center p-10"><mat-spinner diameter="32"></mat-spinner></div>
        } @else if (error() !== null) {
        <p class="p-10 text-center text-sm text-red-600">{{ error() || ('exitTicketPrint.loadFailed' | translate) }}</p>
        } @else {
        <div class="ept-sheet">
            @for (page of pages(); track $index) {
            <div class="ept-page">
                @for (code of page; track code.id) {
                <div class="ept-ticket">
                    <div class="ept-card">
                        <div class="ept-logo-row">
                            <span class="ept-rule"></span>
                            <img class="ept-logo" src="assets/logo-jjames.webp" alt="JJames Smartparking" />
                            <span class="ept-rule"></span>
                        </div>

                        <div class="ept-columns">
                            <div class="ept-col">
                                <div class="ept-banner">
                                    <div class="ept-banner-title">AUSFAHRT</div>
                                    <div class="ept-banner-sub">BITTE FOLGEN SIE DEN SCHRITTEN:</div>
                                </div>
                                <ol class="ept-steps">
                                    <li>
                                        <span class="ept-num">1</span><span class="ept-pre"><mat-icon class="ept-icon">qr_code_scanner</mat-icon></span>
                                        <span class="ept-text">QR-Code mit dem Handy scannen</span>
                                    </li>
                                    <li>
                                        <span class="ept-num">2</span><span class="ept-pre"><span class="ept-plate">AB123CD</span></span>
                                        <span class="ept-text">Kennzeichen eingeben<span class="ept-hint">Ohne Leerzeichen und ohne Bindestrich</span></span>
                                    </li>
                                    <li>
                                        <span class="ept-num">3</span><span class="ept-pre"><mat-icon class="ept-icon">directions_car</mat-icon></span>
                                        <span class="ept-text">Jederzeit ausfahren</span>
                                    </li>
                                </ol>
                            </div>

                            <div class="ept-qr">
                                <qrcode [qrdata]="redeemUrl(code)" [width]="150" [margin]="1" errorCorrectionLevel="M"
                                    elementType="svg" [colorDark]="'#000000'" [colorLight]="'#FFFFFF'"></qrcode>
                                <div class="ept-code">{{ code.token }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="ept-link">
                        <div>Sie können den QR-Code nicht einscannen? Klicken Sie auf den Link</div>
                        <div class="ept-url">{{ redeemUrl(code) }}</div>
                    </div>

                    <div class="ept-fields">
                        <div><b>Ausgestellt von:</b> {{ issuedBy }}</div>
                        <div><b>Ausgestellt am:</b> {{ issuedOn }}</div>
                        <div><b>Gültig bis:</b> {{ validUntil }}</div>
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
</div>
